import MarketplaceItemData from './MarketplaceItemData'

export default MarketplaceItemData
